import { useState } from 'react'

import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'

import { FieldsHomeConf, FieldsHomeGeneral } from '../fields'

const HomeContent = (props) => {
  const { data, setData, edit, optionsWafers, productGroup, products, familys } = props

  const [tab, setTab] = useState(0)

  const handleChange = (productId, name, value) => {
    setData((prev) => ({
      ...prev,
      products: prev.products.map((product) =>
        product.id === productId ? { ...product, [name]: value } : product
      ),
    }))
  }

  function renderTabs(index) {
    switch (index) {
      case 0:
        return (
          <InputsWithoutValidate
            fields={FieldsHomeGeneral(
              data,
              optionsWafers,
              productGroup,
              handleChange,
              products,
              edit,
              familys
            )}
            spacing={2}
          />
        )
      case 1:
        return (
          <InputsWithoutValidate
            fields={FieldsHomeConf(data, optionsWafers, productGroup, handleChange, products, edit)}
            spacing={2}
          />
        )
      default:
        break
    }
  }

  const verticalTabs = [
    {
      id: 0,
      title: 'General',
    },
    {
      id: 1,
      title: 'Configuración',
    },
  ]

  return (
    <div>
      <ContentWithSubTabs
        listVerticalTabs={verticalTabs}
        value={tab}
        setValue={setTab}
        children={<div style={{ margin: '20px' }}>{renderTabs(tab)}</div>}
      />
    </div>
  )
}

export default HomeContent
